import React from 'react'

import InsideWallModel from './InsideWallModel'
import OutsideWallModel from './OutsideWallModel'

const RightStorage = () => {
    return (
        <>
            <OutsideWallModel />
            <InsideWallModel />
        </>
    )
}

export default RightStorage